import BaseService from './BaseService'

class LogsService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  metric = (data: { [key: string]: any }) => {
    const index = `frontend-performance-${new Date().toISOString().split('T')[0]}`
    return this.requests.post(`/metric`, { index, body: data })
  }

  dump = (indexPrefix: string, data: { [key: string]: any }) => {
    const index = `${indexPrefix}-${new Date().toISOString().split('T')[0]}`
    return this.requests.post(`/metric`, { index, body: data })
  }
}

const instance = new LogsService(BaseService.servicesConfig.Logs)

export default instance
